export default "__VITE_ASSET__Di2biTv0__"